export default __webpack_public_path__ + "static/fenerbahce-logo-9d3b28b1cecc0f090783575d8fa05328.png";